import { EException } from 'types/response-code/short-link';

export const shortLinkErrorMessageInfo: Record<EException, string> = {
  '-1': 'Vui lòng kiểm tra lại thông tin',
  '-2': 'Không tìm thấy dữ liệu',
  '-3': 'Dữ liệu trùng'
};
